/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetRoomingsSuccessfulActionPayload,
  GetRoomingByIdActionPayload,
  GetRoomingByIdSuccessfulActionPayload,
  GetActiveRoomingWithRelationsByIdActionPayload,
  GetActiveRoomingByIdWithRelationsSuccessfulActionPayload,
  CreateRoomingActionPayload,
  CreateRoomingSuccessfulActionPayload,
  UpdateRoomingActionPayload,
  UpdateRoomingSuccessfulActionPayload,
  DeleteRoomingActionPayload,
  DeleteRoomingSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/rooming-data-store';

/* action types */
export enum ActionTypes {
  GetRoomings = '[ROOMING] GetRoomings',
  GetRoomingsSuccessful = '[ROOMING] GetRoomingsSuccessful',
  GetRoomingsFailure = '[ROOMING] GetRoomingsFailure',
  GetRoomingById = '[ROOMING] GetRoomingById',
  GetRoomingByIdSuccessful = '[ROOMING] GetRoomingByIdSuccessful',
  GetRoomingByIdFailure = '[ROOMING] GetRoomingByIdFailure',
  GetActiveRoomingWithRelationsById = '[ROOMING] GetActiveRoomingWithRelationsById',
  GetActiveRoomingByIdWithRelationsSuccessful = '[ROOMING] GetActiveRoomingByIdWithRelationsSuccessful',
  GetActiveRoomingByIdWithRelationsFailure = '[ROOMING] GetActiveRoomingByIdWithRelationsFailure',
  CreateRooming = '[ROOMING] CreateRooming',
  CreateRoomingSuccessful = '[ROOMING] CreateRoomingSuccessful',
  CreateRoomingFailure = '[ROOMING] CreateRoomingFailure',
  UpdateRooming = '[ROOMING] UpdateRooming',
  UpdateRoomingSuccessful = '[ROOMING] UpdateRoomingSuccessful',
  UpdateRoomingFailure = '[ROOMING] UpdateRoomingFailure',
  DeleteRooming = '[ROOMING] DeleteRooming',
  DeleteRoomingSuccessful = '[ROOMING] DeleteRoomingSuccessful',
  DeleteRoomingFailure = '[ROOMING] DeleteRoomingFailure',
  ResetState = '[ROOMING] ResetState',
}

/* actions */

/* This event gets the all Roomings. */
export const GetRoomings = createAction(ActionTypes.GetRoomings);

/* This event is fired after getting all the Roomings successfully. */
export const GetRoomingsSuccessful = createAction(
  ActionTypes.GetRoomingsSuccessful,
  props<{ payload: GetRoomingsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Roomings. */
export const GetRoomingsFailure = createAction(ActionTypes.GetRoomingsFailure);

/* This event gets the Rooming by Rooming id. */
export const GetRoomingById = createAction(
  ActionTypes.GetRoomingById,
  props<{ payload: GetRoomingByIdActionPayload }>(),
);

/* This event is fired after getting Rooming by Rooming id successfully. */
export const GetRoomingByIdSuccessful = createAction(
  ActionTypes.GetRoomingByIdSuccessful,
  props<{ payload: GetRoomingByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Rooming by Rooming id. */
export const GetRoomingByIdFailure = createAction(
  ActionTypes.GetRoomingByIdFailure,
);

/* This event gets the active Rooming by Rooming id. */
export const GetActiveRoomingWithRelationsById = createAction(
  ActionTypes.GetActiveRoomingWithRelationsById,
  props<{ payload: GetActiveRoomingWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Rooming by Rooming id successfully. */
export const GetActiveRoomingByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveRoomingByIdWithRelationsSuccessful,
  props<{
    payload: GetActiveRoomingByIdWithRelationsSuccessfulActionPayload;
  }>(),
);

/* This event is fired after couldn't get the Rooming by Rooming id. */
export const GetActiveRoomingByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveRoomingByIdWithRelationsFailure,
);

/* This event creates a Rooming. */
export const CreateRooming = createAction(
  ActionTypes.CreateRooming,
  props<{ payload: CreateRoomingActionPayload }>(),
);

/* This event is fired after creating a Rooming successfully. */
export const CreateRoomingSuccessful = createAction(
  ActionTypes.CreateRoomingSuccessful,
  props<{ payload: CreateRoomingSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Rooming successfully. */
export const CreateRoomingFailure = createAction(
  ActionTypes.CreateRoomingFailure,
);

/* This event updates a Rooming. */
export const UpdateRooming = createAction(
  ActionTypes.UpdateRooming,
  props<{ payload: UpdateRoomingActionPayload }>(),
);

/* This event is fired after updating a Rooming successfully. */
export const UpdateRoomingSuccessful = createAction(
  ActionTypes.UpdateRoomingSuccessful,
  props<{ payload: UpdateRoomingSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Rooming successfully. */
export const UpdateRoomingFailure = createAction(
  ActionTypes.UpdateRoomingFailure,
);

/* This event deletes a Rooming. */
export const DeleteRooming = createAction(
  ActionTypes.DeleteRooming,
  props<{ payload: DeleteRoomingActionPayload }>(),
);

/* This event is fired after deleting a Rooming successfully. */
export const DeleteRoomingSuccessful = createAction(
  ActionTypes.DeleteRoomingSuccessful,
  props<{ payload: DeleteRoomingSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Rooming successfully. */
export const DeleteRoomingFailure = createAction(
  ActionTypes.DeleteRoomingFailure,
);

/* This event resets the Rooming state. */
export const ResetState = createAction(ActionTypes.ResetState);
